import React from 'react';
import { useTranslation } from 'react-i18next';

import MFormPage from 'views/MForm/MFormPage/MFormPage';
import MIcon from 'views/MIcon/MIcon';
import MTabs from 'views/MTabs/MTabs';
import { TabsOrentations } from 'views/MTabs/MTabs.model';
import MTabsPane from 'views/MTabs/MTabsPane/MTabsPane';

import { IUserProfileTab } from './UserProfile.model';
import classes from './UserProfile.module.scss';

type Props = {
  tabs: IUserProfileTab[];
};

const UserProfileView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <MFormPage
      isFullScreen
      header={<span className={classes['pageName']}>{t('userProfile.pageTitle')}</span>}
      formJSX={null}
    >
      <div className={classes['container']}>

        <div className={classes['content']}>
          <MTabs activeTab={props.tabs[0].key} orientation={TabsOrentations.Vertical}>
            {props.tabs.map((tab: IUserProfileTab) => {
              return (
                <MTabsPane
                  className={classes['tabsPane']}
                  key={tab.key}
                  id={tab.key}
                  text={
                    <div className={classes['tabButton']}>
                      <MIcon name={tab.icon} />
                      <label className={classes['label']}>{tab.label}</label>
                    </div>
                  }
                >
                  {tab.content}
                </MTabsPane>
              );
            })}
          </MTabs>
        </div>
      </div>
    </MFormPage>
  );
};

UserProfileView.displayName = 'UserProfileView';
UserProfileView.defaultProps = {};

export default UserProfileView;
